import { render, staticRenderFns } from "./ugc-list.vue?vue&type=template&id=1390f25a&scoped=true&"
import script from "./ugc-list.vue?vue&type=script&lang=js&"
export * from "./ugc-list.vue?vue&type=script&lang=js&"
import style0 from "./ugc-list.vue?vue&type=style&index=0&id=1390f25a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390f25a",
  null
  
)

export default component.exports